import colors from '../../../constants/colors';

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
  button: {
    margin: theme.spacing.unit,
    backgroundColor: colors.parimary,
    width: '100px',
  },
  text: {
    color: '#ffffff',
    marginRight: '4px',
  },
  columnRow: {
    paddingRight: '24px',
  },
  colTable: {
    maxWidth: '200px',
  },
  searchWrapper: {
    minHeight: '60px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flexWrap: 'wrap',
    marginBottom: '16px',
    justifyContent: 'space-between',
  },
  filterLabel: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit,
    fontWeight: 500,
  },
  margin: {
    margin: theme.spacing.unit,
  },
  search: {
    minWidth: '180px',
  },
});

export default styles;
